import { combineReducers } from "redux";
import AppStateReducer from "./appState";
import SideBarStateReducer from './sideBarState';

export default combineReducers({
    appState: AppStateReducer,
    sidebarState: SideBarStateReducer
});